import firebase from "firebase";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyDhRC5ThJg6iiTKcOBn3EIWV1R33hkFI8o",
  authDomain: "cjcj-ea01c.firebaseapp.com",
  databaseURL: "https://cjcj-ea01c.firebaseio.com",
  projectId: "cjcj-ea01c",
  storageBucket: "cjcj-ea01c.appspot.com",
  messagingSenderId: "729505463763",
  appId: "1:729505463763:web:0421e34c8136351939c326",
  measurementId: "G-TC6D4NZN59"
};

// Initialize Firebase
const firebaseApp = firebase.initializeApp(firebaseConfig);
// firebase.analytics();

export default firebaseApp.firestore();
